module.exports = function() {
  return new Worker(__webpack_public_path__ + "ec09012b8834bc98b3b7.worker.js");
};